import React, { useState, createRef } from 'react'
import { Layout, Breadcrumb, Card, Icon, Drawer, Divider, Switch, Col, Row, message } from 'antd';
import axios from '../utils/request'
import AdminMenu from '../Components/AdminMenu'
import PaySettingWechatPayFrom from '../Components/PaySettingWechatPayForm'
import PaySettingAliPayForm from '../Components/PaySettingAliPayForm'
import PaySettingStripePayForm from '../Components/PaySettingStripePayForm'

function PaySetting(props){
    const { Header, Content, Footer } = Layout;

    //微信支付
    const [weChatPayVisible, setWeChatPayVisible] = useState(false);
    const onWeChatPayClose = () => {
        formWxRef.form.resetFields();//重置表单所有组件
        setWeChatPayVisible(false);
    }
    const showWeChatPayDrawer = () => {
        setWeChatPayVisible(true);
    };

    //支付宝支付
    const [aliPayVisible, setAliPayVisible] = useState(false);
    const onAliPayClose = () => {
        formAliRef.form.resetFields();//重置表单所有组件
        setAliPayVisible(false);
    }
    const showAliPayDrawer = () => {
        setAliPayVisible(true);
    }

    //Stripe支付
    const [stripePayVisible, setStripePayVisible] = useState(false);
    const onStripePayClose = () => {
        formStripeRef.form.resetFields();//重置表单所有组件
        setStripePayVisible(false);
    }
    const showStripePayDrawer = () => {
        setStripePayVisible(true);
    }

    //Icon图标
    const AlipayIcon = () => (<svg t="1580909381835" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1270" width="100%" height="100%"><path d="M1023.795 853.64v6.348a163.807 163.807 0 0 1-163.807 163.807h-696.18A163.807 163.807 0 0 1 0 859.988v-696.18A163.807 163.807 0 0 1 163.807 0h696.181a163.807 163.807 0 0 1 163.807 163.807V853.64z" fill="#009FE9" p-id="1271"></path><path d="M844.836 648.267c-40.952-14.333-95.623-34.809-156.846-57.128a949.058 949.058 0 0 0 90.094-222.573H573.325V307.14h245.711v-43.41l-245.71 2.458V143.33H472.173c-18.223 0-21.704 20.476-21.704 20.476v102.38H204.759v40.952h245.71v61.427H245.712v40.952h409.518a805.522 805.522 0 0 1-64.909 148.246c-128.384-42.795-266.186-77.604-354.233-55.08a213.564 213.564 0 0 0-112.003 63.27c-95.418 116.917-26.21 294.034 175.274 294.034 119.989 0 236.087-67.366 325.771-177.73 134.322 65.932 398.666 176.297 398.666 176.297V701.3s-32.352-4.095-178.96-53.033z m-563.702 144.97c-158.893 0-204.759-124.699-126.336-194.112a191.86 191.86 0 0 1 90.913-46.276c93.575-10.238 189.811 35.629 293.624 86.614-74.941 94.598-166.674 153.774-258.2 153.774z" fill="#FFFFFF" p-id="1272"></path></svg>);
    const WechatIcon = () => (<svg t="1580908897336" viewBox="0 0 1030 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1958" width="100%" height="100%"><path d="M326.4 601.6l-96-204.8v-6.4c0-6.4 0-6.4 6.4-12.8 6.4 0 6.4-6.4 12.8-6.4s6.4 0 12.8 6.4l108.8 76.8c12.8 6.4 25.6 6.4 44.8 6.4l518.4-217.6C838.4 134.4 684.8 64 512 64 230.4 64 0 249.6 0 473.6c0 121.6 70.4 236.8 179.2 307.2 6.4 6.4 12.8 19.2 12.8 25.6v12.8l-25.6 83.2v12.8c0 6.4 6.4 19.2 19.2 19.2h12.8l115.2-64c6.4-6.4 19.2-6.4 25.6-6.4H352c57.6 12.8 108.8 25.6 166.4 25.6 281.6 0 512-185.6 512-409.6 0-64-19.2-134.4-57.6-192L377.6 608h-6.4c-12.8 12.8-32 6.4-44.8-6.4z" p-id="1959" fill="#00c250"></path></svg>);
    const StripeIcon = () => (<svg t="1580909335793" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="550" width="100%" height="100%"><path d="M160 192C107.36 192 64 235.36 64 288v448c0 52.64 43.36 96 96 96h704c52.64 0 96-43.36 96-96V288c0-52.64-43.36-96-96-96z m0 64h704c18.112 0 32 13.888 32 32v448c0 18.112-13.888 32-32 32H160c-18.112 0-32-13.888-32-32V288c0-18.112 13.888-32 32-32z m368 110.016a26.72 26.72 0 0 0-27.008 26.976c0 15.008 11.872 27.008 27.008 27.008a26.88 26.88 0 0 0 27.008-27.008 26.816 26.816 0 0 0-27.008-27.008z m-174.016 24l-43.968 6.976-6.016 39.008-16 3.008-6.016 36H304v75.008c0 19.488 4.864 32.736 15.008 40.96 8.48 6.912 20.736 10.016 37.984 10.016 13.248 0 21.376-2.496 27.008-4v-40c-3.136 0.896-10.24 2.016-15.008 2.016-10.112 0-15.008-5.12-15.008-17.024v-66.976h27.008l6.016-39.008h-32.992zM221.024 432.96c-17.504 0-32.64 4.48-42.976 12.992-10.88 8.896-16 22.4-16 38.016 0 28.256 16.864 39.872 44.992 50.016 18.112 6.368 24 10.88 24 17.984 0 6.88-5.376 11.008-16 11.008-13.12 0-34.88-6.624-49.024-15.008L160 587.008c12.128 6.88 34.752 13.984 58.016 13.984 18.496 0 33.6-3.616 44-12 11.616-9.12 17.984-23.488 17.984-40.992 0-28.864-17.504-40.864-46.016-51.008-15.104-5.632-24-9.12-24-16 0-5.856 4.512-9.984 13.024-9.984 15.616 0 32 6.624 42.976 12l6.016-39.008a118.528 118.528 0 0 0-51.008-11.008z m442.016 0c-15.008 0-28.768 6.88-41.024 20l-1.984-16.992h-46.016v222.016l52-9.024v-50.976c7.904 2.496 15.776 2.976 23.04 2.976 12.864 0 31.488-3.232 45.984-18.976 13.856-15.136 20.992-38.016 20.992-69.024 0-27.36-4.64-48.736-15.008-61.984-9.12-11.872-21.76-18.016-37.984-18.016z m134.976 0c-43.84 0-70.976 32.992-70.976 84.992 0 29.12 6.624 51.136 20.992 65.024 12.864 12.48 32.128 17.984 56 17.984 22.016 0 42.112-4.48 55.008-12.992l-6.016-36a91.072 91.072 0 0 1-44 11.008c-9.984 0-16.992-2.624-21.984-7.008-5.376-4.64-8-11.36-9.024-22.016h85.024c0.256-2.496 0.992-14.24 0.992-17.984 0-25.76-6.016-46.624-16.992-60.992-11.264-14.496-27.648-22.016-49.024-22.016zM480 433.984a31.616 31.616 0 0 0-31.008 22.016l-3.008-20h-44.992v162.016h52v-105.024c6.4-7.872 15.52-11.008 28-11.008 2.752 0 5.504 0.384 8.992 1.024v-48a41.088 41.088 0 0 0-9.984-0.992z m22.016 2.016v162.016h51.968v-162.016z m294.976 32c11.648 0 18.144 11.136 19.008 34.016h-38.016c1.504-23.136 7.136-34.016 19.008-34.016z m-152 4.992c13.12 0 20 13.376 20 40.992 0 15.776-2.24 28.64-6.976 37.024-4.16 7.872-10.528 12-18.016 12a30.272 30.272 0 0 1-14.016-3.008v-76.992c8.768-9.12 16.128-10.016 19.008-10.016z" p-id="551" fill="#6772e5"></path></svg>);

    let initData = {
        id: 0,
        companyID: 0,
        channel: '',
        channelFull: '',
        device: '',
        appID: '',
        appSecret: '',
        pid: '',
        mchid: '',
        key: '',
        publicKey: '',
        privateKey: ''
    };
    const [data, setData] = useState(initData);
    const [currentDevice, setDevice] = useState('');
    const [currentChannel, setChannel] = useState('');
    const [currentChannelFull, setChannelFull] = useState('');

    let formWxRef = createRef();
    const saveWxFormRef = formRef => {
        formWxRef = formRef;
    }

    let formAliRef = createRef();
    const saveAliFormRef = formRef => {
        formAliRef = formRef;
    }

    let formStripeRef = createRef();
    const saveStripeFormRef = formRef => {
        formStripeRef = formRef;
    }

    //获取公司ID
    let companyId = props.match.params.id;
    //获取配置信息
    const getData = (device, channel, channelFull) => {
        axios.get(`/api/CompanyPayConfig/GetByChannel?companyId=${companyId}&device=${device}&channel=${channel}&channelFull=${channelFull}`)
        .then(
            (res) => {
                setDevice(device);
                setChannel(channel);
                setChannelFull(channelFull);

                let requestData = res.data.data;
                if(requestData != null){
                    setData(requestData);
                }
                else{
                    //防止其他表单提交后串数据
                    setData(initData);
                }
                if(channel === 'wx'){
                    showWeChatPayDrawer();
                }
                else if(channel === 'alipay'){
                    showAliPayDrawer();
                }
                else if(channel === 'stripe'){
                    showStripePayDrawer();
                }
            }
        )
    }

    const formWxSubmit = e => {
        e.preventDefault();
        formWxRef.form.validateFields((err, values) => {
            if(!err) {
                let saveData = assignmentData(values);
                //console.log(saveData);
                postData(saveData);
            }
        })
    }

    const formAliSubmit = e => {
        e.preventDefault();
        formAliRef.form.validateFields((err, values) => {
            if(!err) {
                let saveData = assignmentData(values);
                //console.log(saveData);
                postData(saveData);
            }
        })
    }

    const formStripeSubmit = e => {
        e.preventDefault();
        formStripeRef.form.validateFields((err, values) => {
            if(!err) {
                let saveData = assignmentData(values);
                //console.log(saveData);
                postData(saveData);
            }
        })
    }

    //赋值Data
    const assignmentData = values => {
        return {
            id: data.id,
            companyID: Number(companyId),
            channel: currentChannel,
            channelFull: currentChannelFull,
            device: currentDevice,
            appID: values.appId === undefined ? '' : values.appId,
            appSecret: values.appSecret === undefined ? '' : values.appSecret,
            pid: values.pid === undefined ? '' : values.pid,
            mchid: values.mchId === undefined ? '' : values.mchId,
            key: values.key === undefined ? '' : values.key,
            publicKey: values.publicKey === undefined ? '' : values.publicKey,
            privateKey: values.privateKey === undefined ? '' : values.privateKey
        }
    }

    

    //提交请求
    const postData = saveData => {
        axios.post('/api/CompanyPayConfig/Save', saveData)
        .then(
            (res) => {
                if(res.data.status === 'success'){
                    message.success(res.data.message);
                    if(currentChannel === 'wx'){
                        onWeChatPayClose();
                    }
                    else if(currentChannel === 'alipay'){
                        onAliPayClose();
                    }
                    else if(currentChannel === 'stripe'){
                        onStripePayClose();
                    }
                }
            }
        )
    }

    //设备类型
    const useDevice = {
        PC: 'PC',
        WAP: 'WAP',
        IOS: 'IOS',
        ANDROID: 'Android',
        WXAPPLETS: 'WxApplets'
    }

    //渠道类型
    const payChannel = {
        WX: 'wx',
        ALIPAY: 'alipay',
        STRIPE: 'stripe'
    };

    //支付渠道类型
    const payChannelType = {
        STRIPE_WAP: 'StripeWAP',
        ALIPAY_WAP: 'AliWapPay',
        WX_WAP: 'WeChatH5',
        WX_APPLET: 'WeChatLiteApp'
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <AdminMenu />
            <Layout>
            <Header style={{ background: '#fff', padding: 0 }} />
            <Content style={{ margin: '0 16px' }}>
                <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item>首页</Breadcrumb.Item>
                <Breadcrumb.Item>公司管理</Breadcrumb.Item>
                <Breadcrumb.Item>支付配置</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
                    <Divider><Icon type="mobile" />  手机H5</Divider>
                    <Row gutter={16}>
                        <Col span={3}>
                            <Card
                                cover={
                                    <WechatIcon />
                                }
                                bodyStyle={{display:'none'}}
                                actions={[
                                    <Switch size="small" defaultChecked />,
                                    <Icon type="edit" key="edit" onClick={() => {getData(useDevice.WAP, payChannel.WX, payChannelType.WX_WAP)}} />,
                                ]}
                            >
                            </Card>
                        </Col>
                        <Col span={3}>
                            <Card
                                cover={
                                    <AlipayIcon />
                                }
                                bodyStyle={{display:'none'}}
                                actions={[
                                    <Switch size="small" defaultChecked />,
                                    <Icon type="edit" key="edit" onClick={() => {getData(useDevice.WAP, payChannel.ALIPAY, payChannelType.ALIPAY_WAP)}} />,
                                ]}
                            >
                            </Card>
                        </Col>
                        <Col span={3}>
                            <Card
                                cover={
                                    <StripeIcon />
                                }
                                bodyStyle={{display:'none'}}
                                actions={[
                                    <Switch size="small" defaultChecked />,
                                    <Icon type="edit" key="edit" onClick={() => {getData(useDevice.WAP, payChannel.STRIPE, payChannelType.STRIPE_WAP)}} />,
                                ]}
                            >
                            </Card>
                        </Col>
                    </Row>
                    <Divider><Icon type="wechat" />  微信小程序</Divider>
                    <Row gutter={16}>
                        <Col span={3}>
                            <Card
                                cover={
                                    <WechatIcon />
                                }
                                bodyStyle={{display:'none'}}
                                actions={[
                                    <Switch size="small" defaultChecked />,
                                    <Icon type="edit" key="edit" onClick={() => {getData(useDevice.WXAPPLETS, payChannel.WX, payChannelType.WX_APPLET)}} />,
                                ]}
                            >
                            </Card>
                        </Col>
                    </Row>
                    <Drawer
                        title="微信支付配置"
                        width={720}
                        onClose={onWeChatPayClose}
                        visible={weChatPayVisible}
                        bodyStyle={{ paddingBottom: 80 }}
                        >
                        <PaySettingWechatPayFrom 
                            data={data} 
                            onSubmit={formWxSubmit}
                            onClose={onWeChatPayClose}
                            wrappedComponentRef={saveWxFormRef} 
                            />
                    </Drawer>
                    <Drawer
                        title="支付宝支付配置"
                        width={720}
                        onClose={onAliPayClose}
                        visible={aliPayVisible}
                        bodyStyle={{ paddingBottom: 80 }}
                        >
                        <PaySettingAliPayForm 
                            data={data} 
                            onSubmit={formAliSubmit}
                            onClose={onAliPayClose}
                            wrappedComponentRef={saveAliFormRef} 
                            />
                    </Drawer>
                    <Drawer
                        title="Stripe支付配置"
                        width={720}
                        onClose={onStripePayClose}
                        visible={stripePayVisible}
                        bodyStyle={{ paddingBottom: 80 }}
                        >
                        <PaySettingStripePayForm 
                        data={data} 
                        onSubmit={formStripeSubmit}
                        onClose={onStripePayClose}
                        wrappedComponentRef={saveStripeFormRef} 
                        />
                    </Drawer>
                </div>
            </Content>
            <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer>
            </Layout>
        </Layout>
    );
}

export default PaySetting;